import { Component, inject, Input, output } from '@angular/core';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { LFProject } from '@lfw/roesberg.liveforms.core';
import { SettingsService } from '../../../shared/settings/settings.service';

import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lfw-project-list-item',
  templateUrl: './project-list-item.component.html',
  styleUrls: ['./project-list-item.component.css'],
  imports: [MatIcon]
})
export class ProjectListItemComponent {
  @Input() project!: LFProject;
  projectSelected = output<SelectionArguments>();

  private settings = inject(SettingsService);

  public showDescription() {
    if (this.project == undefined || this.settings == undefined) {
      return false;
    }
    return (
      this.settings.settings.orderSettings.showProjectDescription &&
      this.project.shortDescription != undefined &&
      this.project.shortDescription != ''
    );
  }
}
